import React from 'react';
import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

const BackgroundContainer = styled(Box)(({ theme }) => ({
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  overflow: 'hidden',
  zIndex: -1,
  pointerEvents: 'none',
}));

const GradientOrb = styled(Box)(({ theme }) => ({
  position: 'absolute',
  borderRadius: '50%',
  filter: 'blur(100px)',
  opacity: 0.3,
  animation: 'float 20s ease-in-out infinite',
  '@keyframes float': {
    '0%, 100%': {
      transform: 'translate(0, 0) scale(1)',
    },
    '33%': {
      transform: 'translate(30px, -30px) scale(1.1)',
    },
    '66%': {
      transform: 'translate(-20px, 20px) scale(0.9)',
    },
  },
}));

const GridPattern = styled(Box)(({ theme }) => ({
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundImage: `
    linear-gradient(rgba(255, 255, 255, 0.01) 1px, transparent 1px),
    linear-gradient(90deg, rgba(255, 255, 255, 0.01) 1px, transparent 1px)
  `,
  backgroundSize: '50px 50px',
  opacity: 0.5,
}));

export const AnimatedBackground: React.FC = () => {
  return (
    <BackgroundContainer>
      <GradientOrb
        sx={{
          width: '600px',
          height: '600px',
          background: 'radial-gradient(circle, rgba(255,255,255,0.1) 0%, transparent 70%)',
          top: '-200px',
          left: '-200px',
        }}
      />
      <GradientOrb
        sx={{
          width: '800px',
          height: '800px',
          background: 'radial-gradient(circle, rgba(255,255,255,0.05) 0%, transparent 70%)',
          bottom: '-300px',
          right: '-300px',
          animationDelay: '10s',
        }}
      />
      <GradientOrb
        sx={{
          width: '400px',
          height: '400px',
          background: 'radial-gradient(circle, rgba(255,255,255,0.08) 0%, transparent 70%)',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          animationDelay: '5s',
        }}
      />
      <GridPattern />
    </BackgroundContainer>
  );
};